import React, { forwardRef } from "react";
import { useMultiSelectFilterContext } from "../MultiSelectFilter.context";
import { Button, ButtonGroup } from "../../../components";
import { iconDsfrCheckLine, iconDsfrCloseCircleLine } from "@design-system-etat/dsfr-commun";
var MultiSelectFilterSelectAllButton = forwardRef(function (_a, ref) {
    var focusPreviousElement = _a.focusPreviousElement, focusNextElement = _a.focusNextElement;
    var _b = useMultiSelectFilterContext(), multiSelectModel = _b.multiSelectModel, onChange = _b.onChange;
    var selectAllFiltered = function (event) {
        var newValues = multiSelectModel.selectAllFilteredOptions();
        onChange(newValues, event);
    };
    var unselectAllFiltered = function (event) {
        var newValues = multiSelectModel.unselectAllFilteredOptions();
        onChange(newValues, event);
    };
    var onKeyDownButton = function (event) {
        if (event.key === "Tab") {
            if (event.shiftKey) {
                focusPreviousElement();
            }
            else {
                focusNextElement();
            }
            event.preventDefault();
        }
    };
    var isDisabled = multiSelectModel.optionsFilteredFlat.length === 0;
    var hasAllSelected = multiSelectModel.hasAllFilteredOptionsSelected();
    return (React.createElement(ButtonGroup, { className: "ssg-multi-select-filter__buttons", iconPosition: "left" },
        React.createElement(Button, { ref: ref, type: "button", variant: "tertiary", onKeyDown: onKeyDownButton, className: "ssg-multi-select-filter__button", disabled: isDisabled, icon: hasAllSelected ? iconDsfrCloseCircleLine : iconDsfrCheckLine, onClick: hasAllSelected ? unselectAllFiltered : selectAllFiltered }, hasAllSelected ? "Tout désélectionner" : "Tout sélectionner")));
});
export default MultiSelectFilterSelectAllButton;
